import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './context/AuthContext';
import { AttemptProvider } from './context/AttemptContext';
import { ProtectedRoute } from './components/index.jsx';

// Pages
import Login from './pages/Login.jsx';
import Landing from './pages/Landing.jsx';
import Platform from './pages/Platform.jsx';
import Hub from './pages/Hub.jsx';
import Writing from './pages/Writing.jsx';
import Speaking from './pages/Speaking.jsx';
import ReadingExperience from './pages/ReadingExperience.jsx';
import FullExam from './pages/FullExam.jsx';
import Results from './pages/Results.jsx';
import Admin from './pages/Admin.jsx';
import Pricing from './pages/Pricing.jsx';
import CreditHistory from './pages/CreditHistory.jsx';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

export default function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <AttemptProvider>
          <BrowserRouter>
            <Routes>
              {/* Public */}
              <Route path="/" element={<Landing />} />
              <Route path="/landing" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/pricing" element={<Pricing />} />

              {/* Protected — any logged-in user */}
              <Route path="/platform" element={<ProtectedRoute><Platform /></ProtectedRoute>} />
              <Route path="/hub/:examId" element={<ProtectedRoute><Hub /></ProtectedRoute>} />
              <Route path="/writing/:examId" element={<ProtectedRoute><Writing /></ProtectedRoute>} />
              <Route path="/speaking/:examId" element={<ProtectedRoute feature="speaking"><Speaking /></ProtectedRoute>} />
              <Route path="/reading/:examId" element={<ProtectedRoute feature="reading"><ReadingExperience /></ProtectedRoute>} />
              <Route path="/exam/:examId" element={<ProtectedRoute><FullExam /></ProtectedRoute>} />
              <Route path="/results" element={<ProtectedRoute><Results /></ProtectedRoute>} />
              <Route path="/credit-history" element={<ProtectedRoute><CreditHistory /></ProtectedRoute>} />

              {/* Admin only */}
              <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />

              {/* Fallback */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AttemptProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}
